module.exports = {
  textInicial: "Ápice Sistemas",
  versao: "001",
};



// WEBPACK FOOTER //
// ./src/constants.js